import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect } from "react";
import {
  SubmitErrorHandler,
  SubmitHandler,
  useFieldArray,
  useForm,
} from "react-hook-form";
import { WorkDay } from "../api/generated/models/WorkDay.js";
import { Employee } from "../api/generated/models/Employee.js";
import {
  Material,
  WorkDayMaterialRequirement,
} from "../api/generated/index.js";

interface MaterialScheduleFormProps {
  employee: Employee;
  workSchedule: WorkDay;
  materials: Material[];
  onSave: (schedule: WorkDay | null, error: Error | null) => Promise<void>;
}

const getMaterialOptions = (
  materials: Material[],
  requirements: WorkDayMaterialRequirement[],
) => {
  return materials.filter((item) => {
    return (
      requirements.find((requirement) => {
        return requirement.material.id == item.id;
      }) === undefined
    );
  });
};

export const MaterialScheduleForm = (props: MaterialScheduleFormProps) => {
  const [materialOptions, setMaterialOptions] = React.useState<Material[]>(
    getMaterialOptions(
      props.materials,
      props.workSchedule?.materialRequirements || [],
    ),
  );

  const { register, control, handleSubmit } = useForm<WorkDay>({
    defaultValues: props.workSchedule,
  });
  const { fields, append, remove } = useFieldArray<
    WorkDay,
    "materialRequirements",
    "fieldId"
  >({
    control,
    name: "materialRequirements",
    keyName: "fieldId",
  });

  useEffect(() => {
    setMaterialOptions(getMaterialOptions(props.materials, fields));
  }, [fields]);

  const onSubmit: SubmitHandler<WorkDay> = async (data) => {
    console.log(data);
    props.onSave(data, null);
  };
  const onError: SubmitErrorHandler<any> = (errors) => {
    console.log(errors);
    props.onSave(null, new Error("Failed to save schedule"));
  };

  const addMaterialRequirement = (materialId: string) => {
    const material = props.materials.find((item) => item.id === +materialId);
    if (material === undefined) {
      console.log("could not add material, material is unknown");
      return;
    }
    append({
      id: undefined,
      material: material,
      requiredQuantity: 1,
    });
  };

  const removeMaterialRequirement = (index: number) => {
    remove(index);
  };

  return (
    <>
      <div>
        <select
          className="select"
          value={"-1"}
          disabled={materialOptions.length === 0}
          onChange={(e) => addMaterialRequirement(e.target.value)}
        >
          <option disabled={true} value={"-1"}>
            Kies materiaal
          </option>
          {materialOptions.map((materialOption) => (
            <option key={materialOption.id} value={materialOption.id}>
              {materialOption.name}
            </option>
          ))}
        </select>
      </div>

      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className="overflow-x-auto">
          <table className="table">
            <thead>
              <tr>
                <th>Materiaal</th>
                <th>Benodigde hoeveelheid</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((field, index) => (
                <tr key={field.fieldId}>
                  <td>{field.material.name}</td>
                  <td>
                    <input
                      type="text"
                      defaultValue={field.requiredQuantity}
                      {...register(
                        `materialRequirements.${index}.requiredQuantity`,
                        {
                          valueAsNumber: true,
                          required: true,
                        },
                      )}
                      className="input"
                    />
                  </td>
                  <th>
                    <button
                      type="button"
                      className="btn btn-error btn-xs"
                      onClick={() => {
                        removeMaterialRequirement(index);
                      }}
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <input type="submit" className="btn btn-primary" value="Opslaan" />
      </form>
    </>
  );
};
